export var ConnectionNames;
(function (ConnectionNames) {
    ConnectionNames["sports"] = "SportsbookConnection";
    ConnectionNames["betslip"] = "BetSlipConnection";
    ConnectionNames["realityCheck"] = "RealityCheckConnection";
    ConnectionNames["player"] = "PlayerDataConnection";
    ConnectionNames["betsReporting"] = "BetsReportingConnection";
    ConnectionNames["casino"] = "CasinoConnection";
    ConnectionNames["captor"] = "CaptorConnection";
    ConnectionNames["search"] = "SearchConnection";
    ConnectionNames["casinoPlayerActivity"] = "CasinoPlayerActivityAPIConnection";
})(ConnectionNames || (ConnectionNames = {}));
//# sourceMappingURL=index.js.map